import React from "react";
import "./index.less";
import Popup from "./Action";
import { set } from "lodash";
import Basics from "../Basics";
import defaultProps from "./defaultProps";
import { cloneDeep, get, merge } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";

@Connection(defaultProps)
export default class extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.divClass = "yx_input_popup";
    this.submit = () => {};
  }

  validFunction = async (rule, values, callback) => {
    const v = await this.submit();
    if (v == null) {
      callback("");
    } else {
      callback();
    }
  };

  get rules() {
    const rules = get(this.props, "rules", { max: "" });
    return merge(
      {
        validator: {
          validator: this.validFunction,
        },
        max: "",
      },
      rules
    );
  }

  productionHtml = (props) => {
    set(props, "rules.max", "");
    set(props, "getFieldDecoratorParam.valuePropName", "value");
    set(props, "getFieldDecoratorParam.validateTrigger", "submit");
    set(props, "getFieldDecoratorParam.trigger", "onChange");
    set(
      props,
      "children",
      <Popup
        {...this.props}
        actionLoad={({ submit }) => (this.submit = submit)}
      />
    );
    const popup = get(this.props, "popup", true);
    if (popup === false) {
      set(props, "rules", this.rules);
    }
    set(props, "mainClassName", "yx_input_popup_parent");
    let html = Basics.html(props);
    return html;
  };

  render() {
    const props = { ...this.props };
    const Html = this.productionHtml(props);
    return <div className={this.parentClass}>{Html}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Popup/index.js